module.exports = __webpack_public_path__ + "img/bannerlist3.bf6b2276.jpg";